const IMGS = {
  large:
    "https://images.unsplash.com/photo-1608506375591-b90e1f955e4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxjYXIlMjBkZXRhaWxpbmclMjBmb2FtJTIwd2FzaHxlbnwwfHx8fDE3ODI1MjIwMTh8MA&ixlib=rb-4.1.0&q=85",
  interior:
    "https://images.pexels.com/photos/1633602/pexels-photo-1633602.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  exterior:
    "https://images.pexels.com/photos/28995189/pexels-photo-28995189.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  premium:
    "https://images.pexels.com/photos/29922284/pexels-photo-29922284.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  leather:
    "https://images.pexels.com/photos/26871052/pexels-photo-26871052.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  sedan:
    "https://images.unsplash.com/photo-1485291571150-772bcfc10da5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwyfHxwb2xpc2hlZCUyMHNwb3J0cyUyMGNhciUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc4MjUyMjAxOHww&ixlib=rb-4.1.0&q=85",
};

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 lg:py-32 bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-6">
          <span className="divider-red" />
          <span className="section-label">The Work</span>
        </div>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tighter max-w-2xl">
            Detail you can <span className="text-[#E63946]">feel</span>.
            <br />
            Shine you can see.
          </h2>
          <p className="text-zinc-400 max-w-md leading-relaxed">
            A look inside the work — foam baths, ceramic finishes, and interiors brought
            back to life.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 grid-rows-2 gap-4 md:gap-6 auto-rows-[180px] md:auto-rows-[220px]">
          <div className="bento-img-wrap md:col-span-7 md:row-span-2 relative" data-testid="gallery-tile-1">
            <img src={IMGS.large} alt="Detailed black car" />
          </div>
          <div className="bento-img-wrap md:col-span-5" data-testid="gallery-tile-2">
            <img src={IMGS.interior} alt="Luxury interior" />
          </div>
          <div className="bento-img-wrap md:col-span-2" data-testid="gallery-tile-3">
            <img src={IMGS.exterior} alt="Foam exterior wash" />
          </div>
          <div className="bento-img-wrap md:col-span-3" data-testid="gallery-tile-4">
            <img src={IMGS.premium} alt="Premium foam detail" />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 mt-4 md:mt-6">
          <div className="bento-img-wrap md:col-span-5 h-[220px]" data-testid="gallery-tile-5">
            <img src={IMGS.leather} alt="Leather seats detailed" />
          </div>
          <div className="bento-img-wrap md:col-span-7 h-[220px]" data-testid="gallery-tile-6">
            <img src={IMGS.sedan} alt="Polished sedan" />
          </div>
        </div>
      </div>
    </section>
  );
}
